const InfoItems = ({ title, value }) => (
	<tr>
		<td>{title}</td>
		<td className="pl-4 pr-2">:</td>
		<td>{value}</td>
	</tr>
)

export default InfoItems